import { createSlice } from "@reduxjs/toolkit"

export const loaderSlice = createSlice({
  name: "loader",
  initialState: 0,
  reducers: {
    increment: (state) => {
      return state += 1
    },
    decrement: (state) => {
      return state -= 1
    },
    incrementByAmount: (state, action) => {
      return state += action.payload
    },
    decrementByAmount: (state, action) => {
      return state -= action.payload
    }
  }
})

export const { increment, decrement, incrementByAmount, decrementByAmount } = loaderSlice.actions

export default loaderSlice.reducer